import React from 'react';
import { APP_NAME } from '../settings';

const appSettings = {
  appName: `${APP_NAME[0].toUpperCase()}${APP_NAME.slice(1)}`,
};

export const AppSettingsContext = React.createContext();

const AppContext = ({ children }) => (
  <AppSettingsContext.Provider value={appSettings}>
    {children}
  </AppSettingsContext.Provider>
);

export default AppContext;
